

























import { Component, Vue, Prop, State } from 'nuxt-property-decorator'
import { IconNext } from '@klook/klook-icons'

@Component({
  components: {
    IconNext
  }
})
export default class TourRecommendActivitySectionFooter extends Vue {
  @State(state => state.klook.platform) platform!: Data.Platform
  @Prop() text!: string
  @Prop() link!: string

  handleClick() {
    window.location.href = this.$href(this.link)
  }
}
